module.exports = __webpack_public_path__ + "static/media/1-17.a306114f.mp3";